class Address{

    constructor(){
            this.id=-1;
            this.city_id=null;
            this.city_name=null;
            this.mahalat_id=null;
            this.mahalat_name=null;
            this.address="خودم تحویل میگیرم";
            this.latitude=null;
            this.longitude=null;
            this.extra_id=null;
            this.extra_name=null;
    }

    setData(json){
        this.id=json.id;
        this.city_id=json.city_id;
        this.city_name=json.get_city.city_name;
        this.mahalat_id=json.mahalat_id;
        this.mahalat_name=json.get_mahalat.mahalat_name;
        this.address=json.address;
        this.extra_id=json.extra_id;
        this.latitude=json.latitude;
        this.longitude=json.longitude;
    }

}

export default Address;